import { Component, Input, OnDestroy } from "@angular/core";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import { SidenavItemComponent } from "@ankaadia/ui";
import { PrimeIcons } from "primeng/api";
import { Tooltip } from "primeng/tooltip";
import { environment } from "../../../../environments/environment";
import { SidebarAdditionalComponentService } from "../../../shared/primeng/sidebar-additional-component/sidebar-additional-component.service";
import { SettingsService } from "../../../shared/services/settings.service";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { TranslationProposalService } from "../translationProposal.service";

@Component({
  selector: "new-ui-translation-proposal-button",
  templateUrl: "./new-ui-translationProposalButton.component.html",
  imports: [TranslateDirective, SidenavItemComponent, NewUiButton, Tooltip],
})
export class NewUiTranslationProposalButtonComponent implements OnDestroy {
  protected icon = PrimeIcons.ERASER + " text-xl";

  @Input()
  sidebarMode: boolean;

  @Input()
  iconOnly: boolean;

  constructor(
    readonly translationProposalService: TranslationProposalService,
    readonly settingsService: SettingsService,
    readonly additionalComponentService: SidebarAdditionalComponentService
  ) {
    if (environment.newUI) {
      this.additionalComponentService.registerComponentType(NewUiTranslationProposalButtonComponent);
    }
  }

  onClick(event: MouseEvent): void {
    this.translationProposalService.toggle(event.target);
    if (this.translationProposalService.isOn) {
      this.icon = PrimeIcons.POWER_OFF + " text-xl";
    } else {
      this.icon = PrimeIcons.ERASER + " text-xl";
    }
  }

  ngOnDestroy(): void {
    this.translationProposalService.turnOff();
  }
}
